var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTennis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#6740E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0712 8.92873C21.0578 6.91531 18.3994 5.93944 15.7608 6.00291L19.8358 10.0762C22.5128 12.7726 22.5079 17.1291 19.8187 19.8181C17.1296 22.5072 12.7725 22.5133 10.0771 19.8338V19.8351L6.0028 15.7608C5.94058 18.3984 6.91588 21.0583 8.92876 23.0712C12.8338 26.9763 19.1671 26.9763 23.0714 23.0712C26.9761 19.1651 26.9761 12.8339 23.0713 8.92889L23.0712 8.92873Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1579 18.7464C12.1712 19.7548 13.5175 20.3077 14.948 20.3066C16.3774 20.3041 17.7231 19.7463 18.7337 18.7344C19.7456 17.7237 20.3035 16.3782 20.3059 14.9479C20.3083 13.518 19.7554 12.171 18.7471 11.1579L18.6898 11.1006L13.8272 6.23727C12.0316 6.63403 10.3251 7.53122 8.9286 8.92884C7.53337 10.3252 6.63489 12.0306 6.23828 13.8268L11.1037 18.694L11.1579 18.7464Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/Tennis.67a73e500ba1c87375ef52c955e940ef.svg";
export { ForwardRef as ReactComponent };